


export const NEW_COMPLAIN_REQUEST='NEW_COMPLAIN_REQUEST'
export const NEW_COMPLAIN_SUCCESS='NEW_COMPLAIN_SUCCESS'
export const NEW_COMPLAIN_RESET = 'NEW_COMPLAIN_RESET'
export const NEW_COMPLAIN_FAIL='NEW_COMPLAIN_FAIL'
export const ALL_COMPLAINS_REQUEST='ALL_COMPLAINS_REQUEST'
export const ALL_COMPLAINS_SUCCESS='ALL_COMPLAINS_SUCCESS'
export const ALL_COMPLAINS_FAIL='ALL_COMPLAINS_FAIL'
export const DELETE_COMPLAIN_REQUEST='DELETE_COMPLAIN_REQUEST'
export const DELETE_COMPLAIN_SUCCESS='DELETE_COMPLAIN_SUCCESS,'
export const DELETE_COMPLAIN_FAIL='DELETE_COMPLAIN_FAIL,'
export const DELETE_COMPLAIN_RESET='DELETE_COMPLAIN_RESET'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'